/**
 * @module:  选择下属单选组件
 * @author: Liang Huang
 * @date: 2019-10-18 16:32:46
 */
import React, { useState, useEffect, CSSProperties } from 'react';
import { NavBar, Tabs, SearchBar, Icon } from 'antd-mobile';
import { IMembersSel } from '@src/entity/company/project';
import { Empty, LoadingComponent } from '@ywk/mobile-components';
import { observer } from 'mobx-react-lite';
import { useInputFocus } from '@src/utils/hooks';
import SelectedUsers from './selected';
import './style.less';

const data = [{ title: '企业成员' }, { title: '外部成员' }];

interface IProps {
  loading: boolean; // 是否数据请求中
  cancelCallback: Function; // 取消回调
  selected: Function; // 选中数据 可能返回空array
  dataSource: IMembersSel[]; // 数据源
  companyName: string; // 公司名称
  title?: string; // 标题
  className?: string; // className
  isMultiple?: boolean;
  reset?: boolean; // 是否清空
  multilpeUsers?: IMembersSel[]; // 多选选中的用户
  maxLen?: number; // 多选最多选择个数，默认10个，
  singleUser?: IMembersSel;
  withoutInOut?: boolean; // 不区分内外部
}

const SelectMember = observer((props: IProps) => {
  const { cancelCallback, dataSource, selected, loading, companyName, className, singleUser, withoutInOut } = props;
  // keyword
  const [keyword, setKeyword] = useState('');
  // 单选的当前选中用户
  const [user, setUser] = useState<any>(null);

  useEffect(() => {
    if (singleUser) {
      setUser(singleUser);
    } else {
      setUser(null);
    }
  }, [singleUser]);
  useInputFocus(loading);

  // 1,2为内部成员
  let insideMembers = dataSource.filter(v => [1, 2].includes(v.type));
  // 3,4,5为外部成员
  let outsideMembers = dataSource.filter(v => [3, 4, 5].includes(v.type));
  if (keyword) {
    insideMembers = insideMembers.filter(v => v.name.includes(keyword));
    outsideMembers = outsideMembers.filter(v => v.name.includes(keyword));
  }

  function clear() {
    setKeyword('');
  }

  function select(member: IMembersSel) {
    selected && selected(member);
    clear();
  }

  const fullStyle = { paddingBottom: 0 };

  /** 行用户点击 */
  const selectUser = (member: IMembersSel) => {
    // 单选 单选时立即关闭此组件
    setUser(member);
    select(member);
  };

  if (loading) {
    return (
      <div className={`full-content ${className ? className : ''}`} style={fullStyle}>
        <LoadingComponent />
      </div>
    );
  }

  return (
    <div className={`full-content ${className ? className : ''}`} style={fullStyle}>
      <NavBar
        leftContent={<span>取消</span>}
        onLeftClick={() => {
          clear();
          cancelCallback && cancelCallback();
        }}
        className="navbar"
      >
        {props.title || '选择下属'}
      </NavBar>
      {withoutInOut && (
        <div className="member-content" key={0}>
          <SearchBar cancelText="取消" onChange={val => setKeyword(val)} onSubmit={val => setKeyword(val)} />
          <h5>{companyName && companyName}</h5>
          <ul className="member-list">
            {[insideMembers, outsideMembers][0].length ? (
              [insideMembers, outsideMembers][0].map((member: IMembersSel, i) => (
                <li className="member-item" key={i} onClick={() => selectUser(member)}>
                  <div className="row-member">
                    <div className="member-header">
                      <img src={member.avatar} alt="" />
                    </div>
                    <div className="member-name">{member.name}</div>
                  </div>
                  {user && member.uuid === user.uuid ? (
                    <img
                      className="icon-selected"
                      src={require('../../../assets/images/company/icon-filter-select.png')}
                      alt=""
                    />
                  ) : null}
                </li>
              ))
            ) : (
              <Empty txt="没有数据" />
            )}
          </ul>
        </div>
      )}

      {!withoutInOut && (
        <Tabs
          tabs={data}
          onChange={() => {
            clear();
          }}
        >
          {data.map((source, index) => (
            <div className="member-content" key={index}>
              <SearchBar cancelText="取消" onChange={val => setKeyword(val)} />
              <h5>{companyName && companyName}</h5>
              <ul className="member-list">
                {[insideMembers, outsideMembers][index].length ? (
                  [insideMembers, outsideMembers][index].map((member: IMembersSel, i) => (
                    <li className="member-item" key={i} onClick={() => selectUser(member)}>
                      <div className="row-member">
                        <div className="member-header">
                          <img src={member.avatar} alt="" />
                        </div>
                        <div className="member-name">{member.name}</div>
                      </div>
                      {user && member.uuid === user.uuid ? (
                        <img
                          className="icon-selected"
                          src={require('../../../assets/images/company/icon-filter-select.png')}
                          alt=""
                        />
                      ) : null}
                    </li>
                  ))
                ) : (
                  <Empty txt="没有数据" />
                )}
              </ul>
            </div>
          ))}
        </Tabs>
      )}
    </div>
  );
});

const SelectMembers = observer((props: IProps) => {
  const {
    cancelCallback,
    dataSource,
    selected,
    loading,
    companyName,
    className,
    reset,
    isMultiple,
    multilpeUsers
  } = props;
  // keyword
  const [keyword, setKeyword] = useState('');
  // 显示已选中的值
  const [showSelected, setShowSelected] = useState<boolean>(false);
  // 多选选中的用户
  const [users, selectUserFn] = useState<IMembersSel[]>(multilpeUsers || []);

  useEffect(() => {
    if (reset) {
      // 父组件需要清空选中的值
      selectUserFn([]);
    }
    console.log(reset, 'reset');
  }, [reset]);

  useInputFocus(loading);

  useEffect(() => {
    if (multilpeUsers) {
      selectUserFn(multilpeUsers);
    }
  }, [multilpeUsers]);

  // 1,2为内部成员
  let insideMembers = dataSource.filter(v => [1, 2].includes(v.type));
  // 3,4,5为外部成员
  let outsideMembers = dataSource.filter(v => [3, 4, 5].includes(v.type));
  if (keyword) {
    insideMembers = insideMembers.filter(v => v.name.includes(keyword));
    outsideMembers = outsideMembers.filter(v => v.name.includes(keyword));
  }

  function clear() {
    setKeyword('');
  }

  function select(member: IMembersSel | IMembersSel[]) {
    selected && selected(member);
    clear();
  }

  const fullStyle = !isMultiple ? { paddingBottom: 0 } : undefined;
  if (loading) {
    return (
      <div className={`full-content ${className ? className : ''}`} style={fullStyle}>
        <LoadingComponent />
      </div>
    );
  }

  /** 行用户点击 */
  const selectUser = (member: IMembersSel) => {
    // 多选
    const index = users.findIndex(user => user.uuid === member.uuid);
    // 组件中此用户当前被选中时
    if (index > -1) {
      // 取消选中用户
      const temp = [...users];
      temp.splice(index, 1);
      selectUserFn(temp);
    } else if (users.length < (props.maxLen || 10)) {
      selectUserFn([...users, member]);
    }
  };

  /** 选中用户弹窗回调 */
  const selectCloseCb = (members: IMembersSel[]) => {
    let curUserObj = {};
    members.forEach((cur: IMembersSel) => {
      curUserObj[cur.uuid] = true;
    });
    selectUserFn(members);
    // selectUserObjFn(curUserObj);
    setShowSelected(false);
  };

  return (
    <div className={`full-content ${className ? className : ''}`} style={fullStyle}>
      <NavBar
        leftContent={<span>取消</span>}
        onLeftClick={() => {
          clear();
          if (multilpeUsers) {
            selectUserFn(multilpeUsers);
          } else {
            selectUserFn([]);
          }
          cancelCallback && cancelCallback();
        }}
        className="navbar"
      >
        {props.title || '选择下属'}
      </NavBar>
      <Tabs
        tabs={data}
        onChange={() => {
          clear();
        }}
      >
        {data.map((source, index) => (
          <div className="member-content" key={index}>
            <SearchBar
              placeholder="搜索"
              cancelText="取消"
              onChange={val => setKeyword(val)}
              onSubmit={val => setKeyword(val)}
            />
            <h5>{companyName && companyName}</h5>
            <ul className="member-list">
              {[insideMembers, outsideMembers][index].length ? (
                [insideMembers, outsideMembers][index].map((member, i) => (
                  <li className="member-item" key={i} onClick={() => selectUser(member)}>
                    <div className="row-member">
                      <div className="member-header">
                        <img src={member.avatar} alt={member.name} />
                      </div>
                      <div className="member-name">{member.name}</div>
                    </div>
                    {
                      // 设置多选选中效果
                      props.isMultiple && users.find(user => user.uuid === member.uuid) ? (
                        <img
                          className="icon-selected"
                          src={require('../../../assets/images/company/icon-filter-select.png')}
                          alt=""
                        />
                      ) : null
                    }
                  </li>
                ))
              ) : (
                <Empty txt="没有数据" />
              )}
            </ul>
          </div>
        ))}
      </Tabs>
      {
        // 多选footer
        props.isMultiple ? (
          <div className="row-footer">
            <div
              className="nums-item"
              onClick={() => {
                setShowSelected(true);
              }}
            >
              已选择：<span>{users.length}人</span> <Icon type="up" />
            </div>
            <a className="footer-btn-ok" onClick={() => select(users)}>
              确定({users.length}/{props.maxLen || 10})
            </a>
          </div>
        ) : null
      }
      {
        // 选中的用户
        showSelected ? (
          <SelectedUsers
            users={users}
            show={showSelected}
            title={props.title}
            cancelCallback={() => setShowSelected(false)}
            okCallback={selectCloseCb}
          />
        ) : null
      }
    </div>
  );
});

const SelectUnder = observer((props: IProps) => {
  if (props.isMultiple === true) {
    return <SelectMembers {...props} />;
  }

  return <SelectMember {...props} />;
});

export default SelectUnder;
